module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary justify-center"
  }, [_c('v-container', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fluid": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "center": "",
      "right": ""
    },
    on: {
      "click": _vm.redireccion
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "white--text text-xs-center"
  }, [_vm._v("Cotizaciones")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "label": "Desde",
      "prepend-icon": "event",
      "data-vv-delay": "100",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechainicio()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "label": "Hasta",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechafin()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "buscar",
      "label": "Buscar"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcotizacion($event)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Total")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cotizaciones.results), function(cotizacion) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(cotizacion)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editarcotizacion(cotizacion)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(cotizacion.cliente))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(cotizacion.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v("Q. " + _vm._s(cotizacion.total_cotizacion))])])
  }), 0)])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [(_vm.cotizaciones.previous) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.prev(_vm.cotizaciones.previous)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1) : _vm._e(), _vm._v(" "), (_vm.cotizaciones.next) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.cotizaciones.next)
      }
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adad1d7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cotizacion.vue
// module id = 445
// module chunks = 1